<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Unsubscribe</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="text-center mt-50">
                    <h1 id="bnr-heading">Unsubscribe Your Mail</h1>
                    <h2 id="bnr-subheading">Lorem ipsum...</h2>
                </div>
            </div>
        </div>
        <!-- <div class="row align-items-center">
        <h2>Safeguard your employee’s device MProtectt™  - a comprehensive mobile threat defense (MTD)  solution powered with Artificial Intelligence and Machine Learning </h2>
      </div> -->
    </div>
</div>

<div class="container">
    <div class="row mt-4">
        <div class="col-12">
            <p class="text-center Emailheading">{{email}}</p>
            <p class="text-center">is subscribed to our mailing list(s).</p>
            <hr>
            <h2 class="text-center">Unscribe from our mailing list</h2>
            <p class="text-center">To help us improve our services, we would be greatful if you could tell us why:</p>
        </div>
    </div>
    <div class="row">
        <div class="col-4"></div>
        <div class="col-4 text-center mt-4">
            <select id="reasons" name="reasons" [(ngModel)]="reason" class="dropdown dropdown-toggle dropdown-menu mb-4">
                <option value="" disabled>Please select reason</option>
                <option value="Your emails are too frequent">Your emails are too frequent</option>
                <option value="No longer want to receive these mails">No longer want to receive these mails</option>
                <option value="Cyber security is not my area of interest">Cyber security is not my area of interest</option>
                <option value="Other">Other</option>
            </select>
            <!-- <br /> -->
            <button type="submit" class=" btn btn-rectengle mb-4" (click)="unSubscribe()" [disabled]="reason == ''? true : null ">Unsubscribe</button>
        </div>
        <div class="col-4"></div>
    </div>
</div>